module.exports = __webpack_public_path__ + "img/arrow.6bb7b12b.svg";